export const APP_COOKIES = {
  SESSION_STATE: 'session_state',
};
